export const encodeResponses = (
  values: readonly (string | number)[],
  rowLength?: number,
): string => {
  const encoded = values.map(String);
  if (!rowLength || rowLength <= 0) return encoded.join("\t");
  return encoded
    .map(
      (value, index) =>
        value +
        ((index + 1) % rowLength === 0 && index < encoded.length - 1
          ? "\t"
          : ","),
    )
    .join("")
    .replace(/,$/, "");
};
